class AcademicTermRange {
    id: number;
    name: string;
    startDate: Date;
    endDate: Date;
    error: boolean;
    children: AcademicTermRange[];

    constructor(data?: Partial<AcademicTermRange>) {
        Object.assign(this, data);

        this.startDate = this.startDate?.toDate();
        this.endDate = this.endDate?.toDate();
        this.children = this.children?.map(c => new AcademicTermRange(c)) || [];
    }

    replaceRange(updated: AcademicTermRange) {
        const childIndex = this.children.findIndex(c => c.id === updated.id);
        if (childIndex !== -1) {
            this.children[childIndex] = new AcademicTermRange(updated);
        } else {
            this.children.forEach(c => c.replaceRange(updated));
        }
    }

    hasError() {
        return this.error || this.children.some(c => c.hasError());
    }
}

export default AcademicTermRange;
